module.exports = __webpack_public_path__ + "img/zhifu-weixinzhifu.2577e0d1.png";